import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d364874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-wrap" }
const _hoisted_2 = {
  key: 0,
  id: "videoplayer2"
}
const _hoisted_3 = {
  key: 1,
  id: "videoplayer1"
}
const _hoisted_4 = {
  key: 2,
  class: "video-is-off"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "视频已关闭", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "content-wrap" }
const _hoisted_8 = { class: "main-content-body" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "25",
  height: "20",
  viewBox: "0 0 25 20"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("linearGradient", {
      id: "linear-gradient",
      y1: "0.425",
      x2: "1",
      y2: "0.968",
      gradientUnits: "objectBoundingBox"
    }, [
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "0",
        "stop-color": "#fff"
      }),
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "1",
        "stop-color": "gray"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M88.24,179.6a11.812,11.812,0,0,0-11.052-8.191c-.644-.011-1.252,0-1.829.043v4.665a.224.224,0,0,1,.006.043.207.207,0,0,1-.2.207.2.2,0,0,1-.173-.1v.02l-11.244-8H63.8a.207.207,0,0,1-.2-.207.211.211,0,0,1,.114-.187l11.272-8.021v.02a.2.2,0,0,1,.173-.1.207.207,0,0,1,.2.207.223.223,0,0,1-.006.043v4.526q.774-.038,1.625-.023A12.138,12.138,0,0,1,88.24,179.6Zm-12.881-20v.006h-.011Zm0,16.948-.008-.006h.008Z",
    transform: "translate(-63.6 -159.6)",
    fill: "url(#linear-gradient)"
  })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "user-info-2" }
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "user-name" }
const _hoisted_14 = { class: "user-point" }
const _hoisted_15 = { class: "header-wrap" }
const _hoisted_16 = { class: "header" }
const _hoisted_17 = { class: "header-col-1" }
const _hoisted_18 = { class: "header-col-1-r round" }
const _hoisted_19 = { class: "header-col-1-r" }
const _hoisted_20 = { class: "single" }
const _hoisted_21 = { class: "double" }
const _hoisted_22 = { class: "header-col-2" }
const _hoisted_23 = { class: "sum sum-1" }
const _hoisted_24 = { class: "sum sum-2" }
const _hoisted_25 = { class: "sum sum-3" }
const _hoisted_26 = { class: "sum sum-4" }
const _hoisted_27 = { class: "sum sum-5" }
const _hoisted_28 = { class: "map-and-buttons" }
const _hoisted_29 = { class: "buttons" }
const _hoisted_30 = { class: "map-wrap" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "21",
  height: "17",
  viewBox: "0 0 21 17"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("linearGradient", {
      id: "linear-gradient",
      x2: "1",
      y2: "5.602",
      gradientUnits: "objectBoundingBox"
    }, [
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "0",
        "stop-color": "#fff"
      }),
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "1",
        "stop-color": "gray"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(-0.5 1.5)"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "直线_78",
      "data-name": "直线 78",
      d: "M18,1.5H0A1.5,1.5,0,0,1-1.5,0,1.5,1.5,0,0,1,0-1.5H18A1.5,1.5,0,0,1,19.5,0,1.5,1.5,0,0,1,18,1.5Z",
      transform: "translate(2)",
      fill: "url(#linear-gradient)"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "直线_81",
      "data-name": "直线 81",
      d: "M18,1.5H0A1.5,1.5,0,0,1-1.5,0,1.5,1.5,0,0,1,0-1.5H18A1.5,1.5,0,0,1,19.5,0,1.5,1.5,0,0,1,18,1.5Z",
      transform: "translate(2 14)",
      fill: "url(#linear-gradient)"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "直线_79",
      "data-name": "直线 79",
      d: "M6,1.5H0A1.5,1.5,0,0,1-1.5,0,1.5,1.5,0,0,1,0-1.5H6A1.5,1.5,0,0,1,7.5,0,1.5,1.5,0,0,1,6,1.5Z",
      transform: "translate(2 7)",
      fill: "url(#linear-gradient)"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "直线_80",
      "data-name": "直线 80",
      d: "M6,1.5H0A1.5,1.5,0,0,1-1.5,0,1.5,1.5,0,0,1,0-1.5H6A1.5,1.5,0,0,1,7.5,0,1.5,1.5,0,0,1,6,1.5Z",
      transform: "translate(14 7)",
      fill: "url(#linear-gradient)"
    })
  ])
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "left-button-group" }
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"14\" viewBox=\"0 0 10 14\" data-v-0d364874><g id=\"Component_399_1\" data-name=\"Component 399 – 1\" opacity=\"0.5\" data-v-0d364874><g id=\"Ellipse_171\" data-name=\"Ellipse 171\" fill=\"none\" stroke=\"#fff\" stroke-width=\"1\" data-v-0d364874><circle cx=\"5\" cy=\"5\" r=\"5\" stroke=\"none\" data-v-0d364874></circle><circle cx=\"5\" cy=\"5\" r=\"4.5\" fill=\"none\" data-v-0d364874></circle></g><path id=\"Subtraction_58\" data-name=\"Subtraction 58\" d=\"M-9139-978a3,3,0,0,1-3-3,3,3,0,0,1,3-3,3,3,0,0,1,3,3A3,3,0,0,1-9139-978Zm-1-5a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-9140-983Z\" transform=\"translate(9144 986)\" fill=\"#fff\" data-v-0d364874></path><rect id=\"Rectangle_482\" data-name=\"Rectangle 482\" width=\"2\" height=\"3\" transform=\"translate(4 9)\" fill=\"#fff\" data-v-0d364874></rect><rect id=\"Rectangle_483\" data-name=\"Rectangle 483\" width=\"8\" height=\"2\" rx=\"1\" transform=\"translate(1 12)\" fill=\"#fff\" data-v-0d364874></rect></g></svg><span data-v-0d364874>全景</span>", 2)
const _hoisted_36 = [
  _hoisted_34
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13.45",
  height: "9.183",
  viewBox: "0 0 13.45 9.183"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M-4127,456a2,2,0,0,1-2-2v-5.183a2,2,0,0,1,2-2h5.077a2,2,0,0,1,2,2V454a2,2,0,0,1-2,2Zm10.257-1.108-3.18-1.738v-3.477l3.18-1.738c.713-.307,1.193-.078,1.193.637v5.66a.684.684,0,0,1-.7.773A1.187,1.187,0,0,1-4116.743,454.892Z",
    transform: "translate(4129 -446.816)",
    fill: "#fff",
    opacity: "0.5"
  })
], -1))
const _hoisted_38 = {
  key: 0,
  class: "right-button-group"
}
const _hoisted_39 = {
  key: 0,
  class: "ceter-content-group"
}
const _hoisted_40 = { class: "all-bet" }
const _hoisted_41 = { class: "table-name" }
const _hoisted_42 = { class: "game-id" }
const _hoisted_43 = { class: "bet-info" }
const _hoisted_44 = { class: "toast-box" }
const _hoisted_45 = { class: "bottom-content-body" }
const _hoisted_46 = {
  key: 0,
  class: "container"
}
const _hoisted_47 = { class: "chip-content-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_loader = _resolveComponent("video-loader")!
  const _component_svg_coin_2 = _resolveComponent("svg-coin-2")!
  const _component_r_map = _resolveComponent("r-map")!
  const _component_timer = _resolveComponent("timer")!
  const _component_bet_group = _resolveComponent("bet-group")!
  const _component_chips = _resolveComponent("chips")!
  const _component_switch_table = _resolveComponent("switch-table")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: "game-root",
    onMouseup: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleOnMouseUp && _ctx.handleOnMouseUp(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.video)
        ? (_openBlock(), _createElementBlock("canvas", _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.video)
        ? (_openBlock(), _createElementBlock("canvas", _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.video)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_ctx.isLoadingVideo)
          ? (_openBlock(), _createBlock(_component_video_loader, {
              key: 3,
              class: "video-loading"
            }))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "back-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toLoby && _ctx.toLoby(...args)))
        }, _hoisted_10),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(["avatar", `avatar${_ctx.avatar}`]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog('avatar')))
          }, null, 2),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.user), 1),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_svg_coin_2, { class: "icon" }),
              _createTextVNode(_toDisplayString(_ctx.coin), 1)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["map-info", { 'full-road': _ctx.isFullMapView }])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, " 局数:" + _toDisplayString(_ctx.mapData.round), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, " 单:" + _toDisplayString(_ctx.mapData.oddCount), 1),
                  _createElementVNode("div", _hoisted_21, " 双:" + _toDisplayString(_ctx.mapData.evenCount), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.mapData.oneCount), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.mapData.twoCount), 1),
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.mapData.threeCount), 1),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.mapData.fourCount), 1),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.mapData.fiveCount), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOddEvenView = !_ctx.isOddEvenView))
              }, _toDisplayString(_ctx.isOddEvenView ? '点数' : '单双'), 1),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isFullMapView = !_ctx.isFullMapView))
              }, _toDisplayString(_ctx.isFullMapView ? '简略' : '全路'), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(), _createBlock(_component_r_map, {
                class: "map",
                "map-data": _ctx.deskResult,
                "bead-row-count": 6,
                display: _ctx.isOddEvenView ? 1 : 0,
                onRoadMapData: _ctx.OnMapDataChange,
                key: _ctx.mapKey
              }, null, 8, ["map-data", "display", "onRoadMapData"]))
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: "menu-button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialog('setting')))
        }, _hoisted_32),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", {
            class: "left-btn btn btn360",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fullVideoView && _ctx.fullVideoView(...args)))
          }, _hoisted_36),
          _createElementVNode("div", {
            class: "left-btn btn btn360",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleVideoState && _ctx.toggleVideoState(...args)))
          }, [
            _hoisted_37,
            _createElementVNode("span", null, _toDisplayString(_ctx.videoState === 1 ? '上镜' : '前镜'), 1)
          ]),
          _createElementVNode("div", {
            class: "left-btn btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showSwitchTable = !_ctx.showSwitchTable))
          }, " 换桌 "),
          _createElementVNode("div", {
            class: "left-btn btn",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showControls = !_ctx.showControls))
          }, _toDisplayString(_ctx.showControls ? ' 隐藏' : '显示'), 1)
        ]),
        _createVNode(_Transition, { name: "slide-left" }, {
          default: _withCtx(() => [
            (_ctx.showControls)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn _c2", { 'is-off': !_ctx.hasTempBet }]),
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.confirmBet && _ctx.confirmBet(...args)))
                  }, " 确定 ", 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn _c3", { 'is-off': !_ctx.hasTempBet }]),
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clearBet && _ctx.clearBet(...args)))
                  }, " 取消 ", 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fadein-out" }, {
          default: _withCtx(() => [
            _createVNode(_component_timer, {
              class: "timer",
              count: _ctx.currentCount
            }, null, 8, ["count"])
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fadein-out" }, {
          default: _withCtx(() => [
            (_ctx.showControls)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, "经典番摊" + _toDisplayString(_ctx.deskNo) + "台", 1),
                    _createElementVNode("div", _hoisted_42, "编号：" + _toDisplayString(_ctx.desk?.gameId), 1),
                    _createElementVNode("div", _hoisted_43, " 总投注：" + _toDisplayString(_ctx.desk?.allBet || 0), 1)
                  ]),
                  _createVNode(_component_bet_group, {
                    class: "center-content",
                    "allow-bet": _ctx.allowBet,
                    onBetChange: _ctx.onBetChange,
                    ref: "betGroup",
                    "desk-data": _ctx.desk,
                    coin: _ctx.coin,
                    result: _ctx.funtanResult,
                    desk: _ctx.deskProps.desk,
                    "chip-value": _ctx.chipValue,
                    "is-switch-table-is-visible": _ctx.showSwitchTable
                  }, null, 8, ["allow-bet", "onBetChange", "desk-data", "coin", "result", "desk", "chip-value", "is-switch-table-is-visible"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_TransitionGroup, {
            class: "toast-container",
            tag: "div",
            name: "list",
            appear: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toastMessage, (toast, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["toast", toast.color]),
                  key: index
                }, [
                  _createElementVNode("span", null, _toDisplayString(toast.message), 1)
                ], 2))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createVNode(_Transition, { name: "slide-up" }, {
          default: _withCtx(() => [
            (_ctx.showControls)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_chips, { class: "chips-scroll" })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        (_ctx.showSwitchTable)
          ? _withDirectives((_openBlock(), _createBlock(_component_switch_table, {
              key: 0,
              class: "switch-table",
              onSelectDesk: _ctx.onTableChange
            }, null, 8, ["onSelectDesk"])), [
              [_directive_click_outside, _ctx.hideSwitchTable]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}